"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

var _Spinner = _interopRequireDefault(require("@components/Spinner"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _useScript = _interopRequireDefault(require("@hooks/useScript"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ARENGU_SDK_LOADED = 'af-init';
var ArenguForm = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      _ref$hiddenFields = _ref.hiddenFields,
      hiddenFields = _ref$hiddenFields === void 0 ? null : _ref$hiddenFields,
      classes = _ref.classes,
      _ref$spinnerProps = _ref.spinnerProps,
      spinnerProps = _ref$spinnerProps === void 0 ? {
    variant: 'primary',
    size: 'lg'
  } : _ref$spinnerProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setMounted = _useState2[1];

  var containerRef = (0, _react.useRef)(null);
  var formRef = (0, _react.useRef)({});
  var eventRef = (0, _react.useRef)();
  var statusScript = (0, _useScript["default"])('https://sdk.arengu.com/forms.js', {
    async: true
  });
  var initialHiddenFields = (0, _react.useMemo)(function () {
    return hiddenFields === null || hiddenFields === void 0 ? void 0 : hiddenFields.reduce(function (sum, _ref2) {
      var key = _ref2.key,
          value = _ref2.value;
      return _objectSpread(_objectSpread({}, sum), {}, _defineProperty({}, key, value));
    }, {});
  }, [hiddenFields]);
  (0, _react.useEffect)(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined) {
      eventRef.current = new Event('af-loaded');
    }
  }, [statusScript]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      setHiddenField: function setHiddenField(key, value) {
        var _formRef$current;

        formRef === null || formRef === void 0 ? void 0 : (_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.setHiddenField(key, value);
      }
    };
  }, [formRef]);
  var initSDK = (0, _react.useCallback)(function () {
    return window.ArenguForms.embed(id, containerRef.current, initialHiddenFields).then(function (form) {
      formRef.current = form;

      if (!isMounted) {
        setMounted(true);

        if (eventRef !== null && eventRef !== void 0 && eventRef.current) {
          document.dispatchEvent(eventRef.current);
        }
      }
    });
  }, [eventRef, id, isMounted, containerRef, initialHiddenFields]);
  (0, _react.useEffect)(function () {
    if (!id || isMounted || statusScript === 'ready') {
      return;
    }

    var listener = null;

    var waitLoadEventAndInitSdk = function waitLoadEventAndInitSdk() {
      listener = initSDK.bind(_this);
      document.addEventListener(ARENGU_SDK_LOADED, listener, {
        once: true
      });
    };

    if (window.ArenguForms != null) {
      initSDK();
    } else {
      waitLoadEventAndInitSdk();
    }

    return function () {
      if (listener !== null) {
        document.removeEventListener(ARENGU_SDK_LOADED, listener);
      }
    };
  }, [id, initSDK, isMounted, statusScript]);
  (0, _react.useEffect)(function () {
    function autosize(el) {
      setTimeout(function () {
        el.style.cssText = 'height:auto';
        el.style.cssText = 'height:' + el.scrollHeight + 'px';

        if (el.value === '') {
          el.style.cssText = 'height: 2em';
        }
      }, 0);
    }

    if (isMounted) {
      if (containerRef !== null && containerRef !== void 0 && containerRef.current) {
        var textareas = containerRef.current.querySelectorAll("textarea[id^='af-']");
        textareas.forEach(function (textarea, i) {
          autosize(textarea);
          textarea.addEventListener('keydown', function () {
            autosize(textarea);
          });
        });
        return function () {
          textareas.forEach(function (textarea, i) {
            textarea.removeEventListener('keydown', autosize);
          });
        };
      }
    }
  }, [isMounted, containerRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['form'], classes === null || classes === void 0 ? void 0 : classes.form, !isMounted && 'd-flex justify-content-center', !isMounted ? classes === null || classes === void 0 ? void 0 : classes.unmount : ''),
    ref: containerRef
  }, !isMounted ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], spinnerProps) : null);
});

var _default = /*#__PURE__*/(0, _react.memo)(ArenguForm);

exports["default"] = _default;